import type {CardUser} from "@/components/cardUsers/scripts/types";

const createEmptyCardUser = () => {
    const user: CardUser = {
        id: 0,
        email: "",
        paycardNumber: "",
    }

    return user;
}

const resetCardUserObject = (originalObject: CardUser, changedObject: CardUser) => {
    changedObject.id = originalObject.id;
    changedObject.email = originalObject.email;
    changedObject.paycardNumber = originalObject.paycardNumber;
}

const cardUserHasChanges = (originalObject: CardUser, changedObject: CardUser) => {
    return changedObject.id !== originalObject.id
    || changedObject.email !== originalObject.email
    || changedObject.paycardNumber !== originalObject.paycardNumber;
}

export {
    createEmptyCardUser,
    resetCardUserObject,
    cardUserHasChanges
}
